import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { axiosInstanceNew } from 'src/utils/axios';

function getApiErrorMessage(err, fallback) {
  return err?.response?.data?.message || err?.response?.data?.error || err?.message || fallback;
}

export const fetchProfitPercent = createAsyncThunk(
  'clientProfit/fetchProfitPercent',
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosInstanceNew.get('/settings/profit-percent');

      return {
        profitPercent: res.data?.profitPercent ?? null,
        totalVolumeUsd: res.data?.totalVolumeUsd ?? null,
      };
    } catch (err) {
      return rejectWithValue(getApiErrorMessage(err, 'Failed to fetch profit percent'));
    }
  }
);

const initialState = {
  profitPercent: null,
  totalVolumeUsd: 0,
  loading: false,
  error: null,
  lastUpdatedAt: null,
};

const clientProfitSlice = createSlice({
  name: 'clientProfit',
  initialState,
  reducers: {
    profitPercentSet(state, action) {
      state.profitPercent = action.payload;
      state.error = null;
      state.lastUpdatedAt = Date.now();
    },
    profitPercentCleared(state) {
      state.profitPercent = null;
      state.error = null;
      state.lastUpdatedAt = null;
    },
    totalVolumeUsdSet(state, action) {
      state.totalVolumeUsd = action.payload;
      state.error = null;
      state.lastUpdatedAt = Date.now();
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProfitPercent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProfitPercent.fulfilled, (state, action) => {
        state.loading = false;
        state.profitPercent = action.payload?.profitPercent ?? null;
        state.totalVolumeUsd = Number(action.payload?.totalVolumeUsd ?? 0);
        state.lastUpdatedAt = Date.now();
      })
      .addCase(fetchProfitPercent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch profit percent';
      });
  },
});

export const { profitPercentSet, profitPercentCleared, totalVolumeUsdSet } =
  clientProfitSlice.actions;

export default clientProfitSlice.reducer;
